import React from 'react';

export const Subtitle1 = ({ name }) => {
  return (
    <>
      <p
        style={{
          lineHeight: '18px',
          width: '30%',
        }}
        className="mb-0 mr-1">
        Editando información de:
      </p>
      <p
        style={{
          fontSize: '16px',
        }}
        className="mb-0 font-weight-bold">
        {name}
      </p>
    </>
  );
};

export default Subtitle1;
